/**
 * router.js — programmatic TanStack Router definitions.
 * No file-based routing. All routes defined here.
 */
import { createRouter, createRoute, createRootRoute } from '@tanstack/react-router';
import RootLayout from './components/RootLayout.jsx';
import HomePage from './pages/HomePage.jsx';
import FoundryPage from './pages/FoundryPage.jsx';
import FoundryPerthPage from './pages/FoundryPerthPage.jsx';
import AutomatedSystemsPage from './pages/AutomatedSystemsPage.jsx';
import TeamTrainingPage from './pages/TeamTrainingPage.jsx';
import SystemsPage from './pages/SystemsPage.jsx';
import ProcessPage from './pages/ProcessPage.jsx';
import AboutPage from './pages/AboutPage.jsx';
import IntakePage from './pages/IntakePage.jsx';
import NotFoundPage from './pages/NotFoundPage.jsx';
import AdventureLogIndexPage from './pages/AdventureLogIndexPage.jsx';
import AdventureLogPostPage from './pages/AdventureLogPostPage.jsx';
import CaseStudiesIndexPage from './pages/CaseStudiesIndexPage.jsx';
import CaseStudyPage from './pages/CaseStudyPage.jsx';
import StyleguidePage from './pages/StyleguidePage.jsx';
import { PrivacyPolicyPage, SmsTermsPage } from './pages/LegalPage.jsx';

// notFoundComponent (not a '*' route) is how TanStack v1 handles unmatched
// URLs — a literal '*' path never matches; the splat token is '$'.
const rootRoute = createRootRoute({ component: RootLayout, notFoundComponent: NotFoundPage });

const indexRoute = createRoute({ getParentRoute: () => rootRoute, path: '/', component: HomePage });
const foundryRoute = createRoute({ getParentRoute: () => rootRoute, path: '/foundry', component: FoundryPage });
const foundryPerthRoute = createRoute({ getParentRoute: () => rootRoute, path: '/foundry/perth', component: FoundryPerthPage });
const automatedSystemsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/automated-systems', component: AutomatedSystemsPage });
const teamTrainingRoute = createRoute({ getParentRoute: () => rootRoute, path: '/team-training', component: TeamTrainingPage });
const systemsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/systems', component: SystemsPage });
const processRoute = createRoute({ getParentRoute: () => rootRoute, path: '/process', component: ProcessPage });
const aboutRoute = createRoute({ getParentRoute: () => rootRoute, path: '/about', component: AboutPage });
const intakeRoute = createRoute({ getParentRoute: () => rootRoute, path: '/intake', component: IntakePage });
const adventureLogsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/adventure-logs', component: AdventureLogIndexPage });
const adventureLogPostRoute = createRoute({ getParentRoute: () => rootRoute, path: '/adventure-logs/$slug', component: AdventureLogPostPage });
const caseStudiesRoute = createRoute({ getParentRoute: () => rootRoute, path: '/case-studies', component: CaseStudiesIndexPage });
const caseStudyRoute = createRoute({ getParentRoute: () => rootRoute, path: '/case-studies/$slug', component: CaseStudyPage });
const styleguideRoute = createRoute({ getParentRoute: () => rootRoute, path: '/styleguide', component: StyleguidePage });

// Compliance pages. These exact paths were submitted to HighLevel for A2P
// 10DLC registration and are quoted verbatim in outbound SMS — never rename.
const privacyPolicyRoute = createRoute({ getParentRoute: () => rootRoute, path: '/privacy-policy', component: PrivacyPolicyPage });
const smsTermsRoute = createRoute({ getParentRoute: () => rootRoute, path: '/sms-terms', component: SmsTermsPage });

export const routeTree = rootRoute.addChildren([
  indexRoute,
  foundryRoute,
  foundryPerthRoute,
  automatedSystemsRoute,
  teamTrainingRoute,
  systemsRoute,
  processRoute,
  aboutRoute,
  intakeRoute,
  adventureLogsRoute,
  adventureLogPostRoute,
  caseStudiesRoute,
  caseStudyRoute,
  styleguideRoute,
  privacyPolicyRoute,
  smsTermsRoute,
]);

export const router = createRouter({ routeTree });
